<template>
    <div id="new_appraisal">
        <h1 class="ui header">
            <!-- 新增考績 -->
            {{ $t('ui.page_titles.new_appraisal') }}
        </h1>
        <div v-if="is_initialized">
            <form class="ui form">
                <div class="field">
                    <!-- 分數 -->
                    <label>{{ $t('ui.pages.appraisals.point') }}</label>
                    <input type="number" v-model="appraisal.point">
                </div>
                <div class="field">
                    <!-- 事由 -->
                    <label>{{ $t('ui.pages.appraisals.reason') }}</label>
                    <input type="text" v-model="appraisal.reason">
                </div>
                <button class="ui basic positive button" @click.prevent="create">
                    {{ $t('ui.general.create') }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function () {
        return {
            is_initialized: false,
            is_processing: false,
            appraisal: {},
            errors: [],
        }
    },
    created: function() {
        this.init();
    },
    mounted: function() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_appraisal") {
                this.init();
            }
        },
    },
    computed: {
    },
    methods: {
        init: async function() {
            var that = this;
            await new Promise(resolve => {
                that.is_initialized =  false;
                that.is_processing =  false;
                that.appraisal =  {
                    point: 0,
                    reason: this.$t('ui.pages.appraisals.reason'),
                    staff_identity: that.$route.params.staff_identity,
                };
                that.errors =  [];
                resolve();
            });
            await new Promise(resolve => {
                that.is_initialized = true;
            });
        },
        create: function() {
            var that = this;
            that.is_processing = true;
            that.errors = [];
            // Prepare parameters
            var params = that.appraisal;
            var url = new RestUrl(that.$store.state.provider.routes.api_v1_provider_appraisal_create).parse(
                {},
                ""
            );

            axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(function (response) {
                if (response.data.status == "success") {
                    that.$router.push('/provider/appraisals/' + that.$route.params.staff_identity);
                    // that.$noty.success("考績建立成功");
                    that.$noty.success(
                        that.$t('ui.notifications.success.create__name', {
                            name: that.$t('models.appraisals')
                        })
                    );
                } else {
                    // that.$noty.error("考績建立失敗");
                    that.$noty.error(
                        that.$t('ui.notifications.error.create__name', {
                            name: that.$t('models.appraisals'),
                            reason: ": " + response.data.errors
                        })
                    );
                    that.errors = response.data.errors;
                }
            })
            .catch(function (error) {
                if (!error.response) {
                    // Network Error
                    that.$noty.error(
                        that.$t('ui.general.network_abnormality')+": "+
                        that.$t('ui.general.server_offline')
                    );
                } else {
                    that.$noty.error(
                        that.$t('ui.general.network_abnormality') + ': ' +
                        error.response.status +
                        error.response.data
                    );
                }
            });
            that.is_processing = false;
        },
    },
    components: {
    }
}
</script>

<style scoped>
</style>
